import { createElement } from 'react';
import './index.scss';
import closeIcon from '../../assets/icon/search-history-list/close.png';
import timeIcon from '../../assets/icon/search-history-list/time.png';
import { convertChildren } from '../../../src/utils/children-node-handle';
const SearchHistoryList = (props) => {
    const { iconSrc = '', dataList, isShowDelete = true, isLeftIcon, children, ...otherProps } = props;
    const deleteItem = (index) => {
        dataList.splice(index, 1);
    };
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "search-history-list", ..._otherProps }, dataList &&
        dataList.map((item, index) => (createElement("div", { className: "search-history-item", key: index },
            createElement("div", { className: "search-history-item-left" },
                isLeftIcon &&
                    convertChildren(children, 'image-1', {
                        imgSrc: iconSrc || timeIcon,
                        className: 'search-history-icon',
                    }),
                convertChildren(children, 'text-1', {
                    children: item.content,
                    className: 'search-history-content',
                })),
            isShowDelete &&
                convertChildren(children, 'image-2', {
                    imgSrc: closeIcon,
                    className: 'search-history-delete',
                    onClick: () => deleteItem(index),
                }))))));
};
export default SearchHistoryList;
